import "./styles.css";
export const DashLayoutGridAutorizar = (props) => {
  return (
    <div className="container-dash-auto">
      <div className="container-login-dash-auto">
        <div className="wrap-login-dash-auto">{props.children}</div>
      </div>
    </div>
  );
};
